﻿import MediumEditor from 'medium-editor';

const mediumSelector = '[data-medium]';
const medium = {
  init: function (element, options) {
	options = { ...medium.defaultOptions, ...options };
	return new MediumEditor(element, options);
  },
  defaultOptions: {
	toolbar: {
	  allowMultiParagraphSelection: false,
	  buttons: ['bold', 'italic', 'underline', 'anchor', 'h2', 'h3'],
	},
	anchor: {
	  placeholderText: 'Incolla o digita un link',
	  targetCheckbox: true,
	  targetCheckboxText: 'Apri in una nuova finestra'
	},
	paste: {
	  forcePlainText: true,
	  cleanPastedHTML: true,
	},
	extensions: {
	  'imageDragging': {}
	}
  }
};


export function initMediumEditor(element, options = {}) {

  if (element.hasAttribute('data-medium')) {
	options = JSON.parse(element.dataset.medium);
  }
  options.placeholder = {
	text: element.placeholder,
	hideOnClick: false,
  }
  return medium.init(element, options);
}

export function initMediumEditors() {
  const mediumInputs = document.querySelectorAll(mediumSelector);
  mediumInputs.forEach((element) => {
	initMediumEditor(element);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initMediumEditors();
})